import type { Dispatch, SetStateAction, ReactElement } from 'react';
import type { BraidDrawerProps } from '../types';
import { Drawer } from 'braid-design-system';

type DrawerOverlayProps = {
  open: boolean;
  setCloseOverlay: Dispatch<SetStateAction<boolean>>;
  title: string;
  description?: ReactElement | boolean | null | undefined;
  children: React.ReactNode;
  width?: BraidDrawerProps['width'];
  id: string;
};

export const DrawerOverlay = ({
  open,
  setCloseOverlay,
  title,
  description,
  children,
  width = 'medium',
  id,
}: DrawerOverlayProps) => (
  <Drawer
    id={id}
    title={title ?? ''}
    description={description}
    open={open}
    onClose={() => setCloseOverlay(false)}
    width={width}
  >
    {children}
  </Drawer>
);
